var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('b-button',{attrs:{"variant":"outline-primary"},on:{"click":function($event){return _vm.createWall()}}},[_vm._v("Create Wall")]),_c('div',{staticClass:"mt-3",attrs:{"id":"createWallInfo"},domProps:{"innerHTML":_vm._s(_vm.createWallInfoMessage)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }